module.exports = __webpack_public_path__ + "img/dhg_arc.2c4e4768.jpg";